import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Note } from '@rocksoft/mdm-sdk-v2';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'era-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss'],
  imports: [ReactiveFormsModule, FaIconComponent, DatePipe],
})
export class NoteComponent {
  @Input() note: Note;
  @Input() editMode = false;

  @Output() private readonly addedEvent: EventEmitter<Note> = new EventEmitter<Note>();
  @Output() private readonly deletedEvent: EventEmitter<Note> = new EventEmitter<Note>();

  public readonly form: UntypedFormGroup;

  constructor(private readonly formBuilder: UntypedFormBuilder) {
    this.form = this.formBuilder.group({
      content: ['', Validators.required],
    });
  }

  public addNote(): void {
    const content = this.form.get('content').value;
    const updatedNote = { ...this.note };
    updatedNote.content = content;
    updatedNote.updatedAt = new Date();
    this.addedEvent.emit(updatedNote);
    this.form.reset();
  }

  public deleteNote(): void {
    this.deletedEvent.emit(this.note);
  }
}
